import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./layouts/RootLayout.js";
import { lazy, Suspense } from "react";
import { TopologyView } from "./views/TopologyView.js";

// Lazy load secondary views
const Dashboard = lazy(() => import("./views/Dashboard.js"));
const SettingsView = lazy(() =>
  import("./views/SettingsView.js").then((m) => ({ default: m.SettingsView })),
);

function LazyWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="h-full flex items-center justify-center">
          <div className="w-6 h-6 border-2 border-brand-purple/30 border-t-brand-purple rounded-full animate-spin" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: (
          <LazyWrapper>
            <Dashboard />
          </LazyWrapper>
        ),
      },
      {
        path: "topology/:topologyId",
        element: <TopologyView />,
      },
      {
        path: "topology",
        element: <TopologyView />,
      },
      {
        path: "settings",
        element: (
          <LazyWrapper>
            <SettingsView />
          </LazyWrapper>
        ),
      },
    ],
  },
]);
